var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 9.474h-6a.54.54 0 0 1-.5-.498v-5.98a.993.993 0 0 0-.17-.567 1.148 1.148 0 0 0-.27-.27A1.003 1.003 0 0 0 13.49 2h-3c-.134 0-.267.028-.39.08-.24.107-.433.299-.54.538a.993.993 0 0 0-.06.379v5.979a.407.407 0 0 1-.05.259.399.399 0 0 1-.22.22.38.38 0 0 1-.15.049H3a1.002 1.002 0 0 0-1 .997v2.989a.995.995 0 0 0 1 .996h6a.541.541 0 0 1 .54.538v5.98c0 .198.059.393.17.557.074.105.166.195.27.27.165.11.36.17.56.169h3c.144 0 .286-.027.42-.08.24-.107.432-.298.54-.538.03-.148.03-.3 0-.448v-5.98a.168.168 0 0 1 0-.069.376.376 0 0 1 0-.15.397.397 0 0 1 .22-.219c.05-.01.1-.01.15 0H21a1.002 1.002 0 0 0 1-.996v-2.99a.993.993 0 0 0-.603-.975 1.003 1.003 0 0 0-.397-.08Zm-.5 2.99a.498.498 0 0 1-.5.498h-6a1.002 1.002 0 0 0-1 .996v5.98a.498.498 0 0 1-.5.498h-1a.501.501 0 0 1-.5-.499v-5.979a.995.995 0 0 0-1-.996H4a.501.501 0 0 1-.5-.498v-.997a.498.498 0 0 1 .5-.498h6a1.002 1.002 0 0 0 1-.997V3.993a.498.498 0 0 1 .5-.498h1a.501.501 0 0 1 .5.498v5.98a.995.995 0 0 0 1 .996h6a.501.501 0 0 1 .5.498v.996Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f9d660d3e4452fedab20ac9a61ddbb03.svg";
export { ForwardRef as ReactComponent };